import { render, staticRenderFns } from "./SidebarFixedToggleButton.vue?vue&type=template&id=a08542fa&"
import script from "./SidebarFixedToggleButton.vue?vue&type=script&lang=js&"
export * from "./SidebarFixedToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports